export const REGIONS = [
  { value: "gta", label: "Greater Toronto Area", desc: "Ontario, Canada" },
  { value: "other", label: "Another location", desc: "Tell us where you are" },
];

export const CITIES = {
  gta: ["Toronto", "Mississauga", "Brampton", "Vaughan", "Markham", "Richmond Hill", "Oakville", "Burlington",
    "Milton", "Pickering", "Ajax", "Whitby", "Oshawa", "Newmarket", "Aurora", "Caledon", "Other community"],
};

export const COMPLETING_FOR = [
  { value: "self", label: "Myself", desc: "I am looking for support for myself" },
  { value: "family", label: "A family member", desc: "I am arranging support for a relative" },
  { value: "friend", label: "A friend or neighbour", desc: "I am helping someone I know" },
  { value: "professional", label: "A client (as a professional)", desc: "Case manager, social worker or similar" },
];

export const AGE_RANGES = ["18–39", "40–64", "65–74", "75–84", "85 or older"];

export const CATEGORY_META = {
  caregiver_application: { label: "Job Candidates", short: "Candidates" },
  partnership: { label: "Corporate and Community Partnerships", short: "Partners" },
  property_owner: { label: "Landlord and Property Inquiries", short: "Property" },
  social_service: { label: "Social Service Professional Inquiries", short: "Social Service" },
  in_home_care: { label: "In-Home Care", short: "Care" },
  housing: { label: "Independent Living", short: "Housing" },
  residential_support: { label: "Assisted Living Interest List", short: "Assisted Living" },
  general: { label: "General Contact", short: "Contact" },
};
export const MAIN_SECTIONS = ["caregiver_application", "partnership", "property_owner", "social_service"];
export const CLIENT_SECTIONS = ["in_home_care", "housing", "residential_support", "general"];
export const PARTNER_STATUSES = ["Awaiting Response", "Response Sent"];

export const REGION_LABELS = {
  gta: "Greater Toronto Area",
  norcal: "Northern California",
  both: "Both regions",
  other: "Other location",
};

export const INQUIRY_STATUSES = ["New", "Contacted", "Follow-Up Required", "Under Review", "Referred", "Closed"];
export const APPLICANT_STATUSES = ["New Application", "Screening", "Interview", "Reference & Credential Check",
  "Talent Pool", "Offer Extended", "Not Proceeding", "Withdrawn"];

export const statusesFor = (category) => (MAIN_SECTIONS.slice(1).includes(category) ? PARTNER_STATUSES
  : category === "caregiver_application" ? APPLICANT_STATUSES : INQUIRY_STATUSES);

export const STATUS_STYLES = {
  "Awaiting Response": "bg-amber-50 text-amber-800 border-amber-200",
  "Response Sent": "bg-emerald-50 text-emerald-800 border-emerald-200",
  New: "bg-blue-50 text-blue-800 border-blue-200",
  "New Application": "bg-blue-50 text-blue-800 border-blue-200",
  Contacted: "bg-amber-50 text-amber-800 border-amber-200",
  "Follow-Up Required": "bg-orange-50 text-orange-800 border-orange-200",
  "Under Review": "bg-sky-50 text-sky-800 border-sky-200",
  Referred: "bg-indigo-50 text-indigo-800 border-indigo-200",
  Closed: "bg-stone-100 text-stone-700 border-stone-200",
  Screening: "bg-amber-50 text-amber-800 border-amber-200",
  Interview: "bg-sky-50 text-sky-800 border-sky-200",
  "Reference & Credential Check": "bg-indigo-50 text-indigo-800 border-indigo-200",
  "Talent Pool": "bg-emerald-50 text-emerald-800 border-emerald-200",
  "Offer Extended": "bg-green-100 text-green-900 border-green-300",
  "Not Proceeding": "bg-stone-100 text-stone-700 border-stone-200",
  Withdrawn: "bg-stone-100 text-stone-700 border-stone-200",
};

export const CODE_LABELS = {
  self: "Myself", family: "A family member", friend: "A friend or neighbour", professional: "A client (professional)",
  independent: "Independent living", shared: "Shared housing", residential_support: "Assisted living care home (interest list)",
  not_sure: "Not sure yet", care_referrals: "Care referrals (case manager / social worker)",
  housing_organization: "Housing organization", community_agency: "Community agency",
  property_owner: "Property owner", landlord: "Landlord", property_manager: "Property manager", other: "Other",
};
